import { Box } from "@mui/material";
import React, { useRef } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import EntityDetail from "../components/Layout/EntityDetail";
import Sidebar from "../components/Layout/Sidebar";
import { ENTITY_PAGE_TYPE_PARAM, entityPath } from "../utils/entityAddress";

/**
 * Standalone page view for entity details
 * Displays entity information in a centered, full-page layout
 * Uses URL parameter :entityId to determine which entity to display
 */
const EntityDetailPage: React.FC = () => {
  const { entityId } = useParams<{ entityId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  // The type travels with the id as a query parameter; an id without one is
  // an organization, facility, project or source
  const entityType = searchParams.get(ENTITY_PAGE_TYPE_PARAM) || undefined;

  // Handle entity navigation - update URL to new entity
  const handleEntityClick = (newEntityId: string, newEntityType?: string) => {
    navigate(entityPath(newEntityId, newEntityType));
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        backgroundColor: "background.paper",
      }}
    >
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content - Full Width with Centered Inner Content */}
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <EntityDetail
          entityId={entityId || ""}
          entityType={entityType}
          onEntityClick={handleEntityClick}
          mode="standalone"
          scrollContainerRef={scrollContainerRef}
        />
      </Box>
    </Box>
  );
};

export default EntityDetailPage;
